export const PAGE_AREA = "pageview.pageAreaEvent";
